import { styled } from "styled-components";
import { Link } from "react-router-dom";
import { Brand } from "./Brand";
import { Container, Grid } from "./UI";
import { services, site } from "../data";

const Wrap = styled.footer`
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.canvasAlt};
  padding: 4rem 0 1.5rem;
`;
const Links = styled.div`
  display:grid; gap:.5rem; align-content:start;
  h3 { font-size:.9rem; text-transform:uppercase; letter-spacing:.11em; color:${({theme})=>theme.colors.muted}; margin:0 0 .5rem;}
  a { text-decoration:none; color:${({theme})=>theme.colors.muted}; }
  a:hover { color:${({theme})=>theme.colors.primary}; }
`;
const Fine = styled.div`
  display:flex; justify-content:space-between; gap:1rem; flex-wrap:wrap; margin-top:3rem; padding-top:1.25rem;
  border-top:1px solid ${({theme})=>theme.colors.border}; color:${({theme})=>theme.colors.muted}; font-size:.88rem;
`;

export function Footer() {
  return (
    <Wrap>
      <Container>
        <Grid $min="190px">
          <div><Brand/><p style={{maxWidth:"38ch"}}>{site.promise}</p><p>{site.location}</p></div>
          <Links><h3>Services</h3>{services.map(s=><Link key={s.slug} to={`/${s.slug}`}>{s.shortName}</Link>)}</Links>
          <Links><h3>Company</h3><Link to="/about">About</Link><Link to="/mission">Mission & Vision</Link><Link to="/pricing">Service Packages</Link><Link to="/faq">FAQ</Link></Links>
          <Links><h3>Connect</h3><Link to="/contact#schedule">Digital Solutions Consultation</Link><Link to="/contact">Contact</Link><a href={`mailto:${site.email}`}>{site.email}</a><a href={`tel:${site.phone.replace(/[^\d+]/g,"")}`}>{site.phone}</a></Links>
        </Grid>
        <Fine><span>© {new Date().getFullYear()} TPeck Digital. All rights reserved.</span><span><Link to="/privacy">Privacy</Link> · <Link to="/accessibility">Accessibility</Link></span></Fine>
      </Container>
    </Wrap>
  );
}
